import axios from "axios";
import { decode } from 'js-base64';

//import Vue from 'vue';
//var MyPlugin = {};
//let ayar = { firmaid:1,kid:2,yetki:'el',ekipid:1,bid:1}
//localStorage.setItem('ayar', JSON.stringify(ayar)) 

const settings = {
  //   domain : "http://localhost:3001/",
domain:"https://api.ayurlifeworld.com/",
   donem : function(){
     const monthNames = [1,2,3,4,5,6,7,8,9,10,11,12]
     let date = new Date();
    return  {gun:date.getDate(),ay:monthNames[date.getMonth()],yil:date.getFullYear()}
    //return  {ay:11,yil:2020}
    },

   ayar: function(){
    if (localStorage.getItem('tfx')){
    let tkn = JSON.parse(localStorage.getItem('tfx'))
    let auth = decode(tkn.auth).split(',')

    let donen = {
      uye:tkn.user.u,
      referans:tkn.user.r,
      //tip:tkn.user.t,
      username:auth[0],
      pass:auth[1],
      uye_ad:auth[2],
      ay:auth[3],
      yil:auth[4]
      //fid:auth[4]/8589
     // page:tkn.pgs
    }
    return donen
 }
}
}
const request = {

   get : function (url) {
      return new Promise((resolve, reject) => {
              axios
              .get(settings.domain+url)
              .then(response => (resolve(response.data)))
              .catch(error => reject(error));
        })
      },
      post (url, data){ // buradaki alt function ile url yi create edebilirsin
        let postObje = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {"Content-type": "application/json; charset=UTF-8"}
        }
            return new Promise ((resolve,reject)=>{
                axios
                .post(settings.domain+url,data)
                .then(response => (resolve(response.data)))
                .catch(error => reject(error));
            })
      },
      put (url, data){ // buradaki alt function ile url yi create edebilirsin
        let postObje = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {"Content-type": "application/json; charset=UTF-8"}
        }
          return new Promise ((resolve,reject)=>{
              axios
              .post(this.domain+url,data)
              .then(response => (resolve(response.data)))
              .catch(error => reject(error));
          })
      }     
  }
const funcs = {
    tabloarama() {
      var e, t, n, a, l;
      for (e = document.getElementById("arama").value.toUpperCase(), t = document.getElementById("tablo").getElementsByTagName("tr"), l = 1; l < t.length; l++) {
        t[l].style.display = "none", n = t[l].getElementsByTagName("td");
        for (var m = 0; m < n.length; m++)
          if ((a = t[l].getElementsByTagName("td")[m]) && a.innerHTML.toUpperCase().indexOf(e) > -1) {
            t[l].style.display = "";
            break
          }
      }
    },
    groupByAdet (array, key) {  //result mart : 5
       return array.reduce((acc, item) => {
        const accAmout = acc[item[key]] || 0;
         return Object.assign(
            {}, acc, {
            [item[key]]: accAmout + 1,
          }
         )
        }
        , {})
    },
    groupByAdet2 (arr){
      arr.forEach(function (a) {
        if ( !this[a.st] ) {
            this[a.st] = { name: a.st, shape: a.ay,adet:0};
            result.push(this[a.st]);
        } 
        this[a.st].adet += +1;
    //   this[a.color].instances += a.instances;
    }, Object.create(null));
    } , 
    group2adet(arr,param2,param1){
      //let deneme = []
      var result = arr.reduce(function(acc, obj) {
        let deneme = {}
          var g1 = acc[obj[param1]] = acc[obj[param1]] || {};
          var g2 = g1[obj[param2]] = g1[obj[param2]] || {count: 0 };
          g2.count++;
          //let deneme = {data:[g2.count++]}
          return acc;
        }, Object.create(null));
        return result;
    },
    trtgoster(uzuntarih){
      const monthNames = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12" ];
      const d = new Date(uzuntarih);
      return d.getDate() +'-'+ monthNames[d.getMonth()]+'-'+d.getFullYear();
    },
    trtgosternoktali(uzuntarih){
      const monthNames = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12" ];
      const d = new Date(uzuntarih);
      return d.getDate() +'.'+ monthNames[d.getMonth()]+'.'+d.getFullYear();
    },
    trtyazdir(sadecetarih){
      const monthNames = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12" ];
      const d = new Date(sadecetarih);
      return d.getFullYear() +'-'+ monthNames[d.getMonth()]+'-'+d.getDate();
    },
    gunhesapla (t1){
      var MS_one_day = 1000 * 60 * 60 * 24;
      var y = new Date();
      var x = new Date(t1);
      var date1= Date.UTC(x.getFullYear(), x.getMonth(), x.getDate()); //x
      var date2 = Date.UTC(y.getFullYear(), y.getMonth(), y.getDate()); //y
      return Math.floor((date2 - date1) / MS_one_day);
    },
    parabirimi(res){
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(res).replace("€","TL")
    },
    aybul(res){
      let monthNames = ["yok","Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık" ];
      monthNames[res]
    },
    tckontrol(value){
      return new Promise((resolve, reject) => {
      value = value.toString();
      var isEleven = /^[0-9]{11}$/.test(value);
      var totalX = 0;
      for (var i = 0; i < 10; i++) {
        totalX += Number(value.substr(i, 1));
      }
      var isRuleX = totalX % 10 == value.substr(10,1);
      var totalY1 = 0;
      var totalY2 = 0;
      for (var i = 0; i < 10; i+=2) {
        totalY1 += Number(value.substr(i, 1));
      }
      for (var i = 1; i < 10; i+=2) {
        totalY2 += Number(value.substr(i, 1));
      }
      var isRuleY = ((totalY1 * 7) - totalY2) % 10 == value.substr(9,0);
     // return isEleven && isRuleX && isRuleY;
     resolve(isEleven && isRuleX && isRuleY)
  
  })
  },
    kdv(fiyat,kdv){
    return fiyat+(fiyat*kdv/100)
  }

  }
  export const helper = {
    request,
    funcs,
    settings
  };



// WEBPACK FOOTER //
// ./src/helper.js